import React from "react";
import "../../account/Account.css"
import Popup from 'reactjs-popup';
import Colors from "../Colors";
import CloseIcon from "mdi-react/CloseCircleOutlineIcon"
import { withRouter } from "react-router-dom";
import ButtonLoader from "../Utilities/ButtonLoader";
import Aux from "../AuxFunctions";
class NotLoggedIn extends React.Component {

    goToLogin = (close) => {
        try{
            this.props.history.push("/account/login")
            close();
        }catch(error){
            Aux.handleError(error)
        }
    }

    goToRegister = (close) => {
        try{
            this.props.history.push("/account/register")
            close();
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {
        return (
            <Popup 
            contentStyle={{width: "auto", borderRadius:10}}
            open={this.props.active} 
            onClose={this.props.onClose}
            closeOnDocumentClick>
                {close => (
                <section style={{display:"flex", width: 300, flexDirection:"column", padding:40}}>
                    {/* <img alt="logo" src={Aux.LogoImage} style={{ width: 50, objectFit: "contain" }}></img> */}
                    <div>
                        <CloseIcon className={"button-hover"} size={30} onClick={close} style={{float: "right"}}></CloseIcon>
                    </div>
                    <h2>You're not logged in</h2>
                    {/* <span>Did you forgot your password?  </span> */}
                    <span style={{color:"#666", margin:"10px 0"}}>You can't perform that action because you're not logged in</span>
                    <div style={{marginTop:20}}>

                    

                         <span style={{color:"#bbb"}}>Already have an account? </span>
                        <ButtonLoader 
                                text="Login" 
                                style={{backgroundColor: Colors.mainColor, padding: "10px 20px", width: "100%", marginTop:10, marginBottom: 10}}
                                onClick={() => this.goToLogin(close)}
                            />

                        <span style={{color:"#bbb", marginTop:10}}>Don't have an account? </span>
                            <ButtonLoader 
                                text="Register" 
                                style={{backgroundColor: Colors.red, padding: "10px 20px", width: "100%", marginTop:10}}
                                onClick={() => this.goToRegister(close)}
                            />
                    </div>

                </section>)}
            </Popup>
        );
    }
}

export default withRouter(NotLoggedIn);